import en from './strings.en';

const ru = {
    header: 'Доступ на 30 дней',
    description: 'Самый быстрый способ найти исполнителя',
    profit: 'ВЫГОДА <p>{{percent}}%</p>',

};

export default { ru, en: { ...ru, ...en} };
